export const validateDEANumber = (deaNumber: string | null): boolean => {
	return deaNumber !== null && deaNumber.length === 9;
};
